import {Component, inject, OnInit} from '@angular/core';

import {environment} from 'src/environments/environment';
import {filter, map, tap} from 'rxjs/operators';
import {ClipboardService} from 'ngx-clipboard';
import {HankoService} from "../sopi/hanko";
import {Router} from "@angular/router";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
    public selectedIndex = 0;
    public appPages = [
        /*{
            title: 'Mandanten Liste',
            url: '/folder/Liste',
            icon: 'list'
        },
        {
            title: 'Mandant anlegen',
            url: '/folder/Anlegen',
            icon: 'add'
        },*/
        {
            title: 'Mandanten verwalten',
            url: '/mandanten',
            icon: 'list'
        },
        {
            title: 'Tools',
            url: '/tools',
            icon: 'warning'
        },
        {
            title: 'Dashboard',
            url: '/dashboard',
            icon: 'dollar'
        }

        // {
        //     title: 'Outbox',
        //     url: '/folder/Outbox',
        //     icon: 'paper-plane'
        // },
        // {
        //     title: 'Favorites',
        //     url: '/folder/Favorites',
        //     icon: 'heart'
        // },
        // {
        //     title: 'Archived',
        //     url: '/folder/Archived',
        //     icon: 'archive'
        // },
        // {
        //     title: 'Trash',
        //     url: '/folder/Trash',
        //     icon: 'trash'
        // },
        // {
        //     title: 'Spam',
        //     url: '/folder/Spam',
        //     icon: 'warning'
        // }
    ];

    public envi = environment;
    private hanko = inject(HankoService);
    private router = inject(Router);

    isLoggedIn$ = this.hanko.isLoggedIn$;
    name$ = this.hanko.myIdentity$.pipe(
        tap(x => console.log(x)),
        filter(x => x !== null),
        map(x => x.mail)
    )

    constructor(
        private clipboardService: ClipboardService
    ) {
    }

    async checkLoggedIn() {
        const resp = await this.hanko.validateSession();
        if (resp.is_valid) {
            await this.router.navigate(['/'], {
                replaceUrl: true,
                onSameUrlNavigation: 'reload',
            });
        }

        return resp.is_valid;
    }

    ngOnInit() {

        this.checkLoggedIn().then(b => {


                if (b) {
                    const path = window.location.pathname.split('mandanten')[1];
                    if (path !== undefined) {
                        // console.log("pages: ", this.appPages);
                        this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
                    }
                }

            }
        );


    }

    async logout() {
        this.hanko.apiLogout().subscribe(r => {
            this.hanko.logout(r?.external_clients);
            this.hanko.startLogin(true);
        });

        await this.router.navigate(['login'], {
            onSameUrlNavigation: 'reload'
        });
    }

    copyToken() {
        const token = this.hanko.getAccessToken();
        this.clipboardService.copyFromContent(token);
    }
}
